export interface Sport {
  uid: string;
  name: string;
}

export interface SportData {
  sport: Sport;
  data?: {
    court?: {
      surface?: string[];
      wallType?: string[];
    };
  };
}

export interface SportExtended extends Sport {
  emoji?: string;
  maxPlayers?: number;
  disabled?: boolean;
}

export type Sports = {
  [key: string]: SportExtended;
};

export const sports: Sports = {
  padel: { emoji: '🎾', name: 'Padel', uid: 'padel', maxPlayers: 2 },
  tenis: { emoji: '🏸', name: 'Tenis', uid: 'tenis', maxPlayers: 1 },
  futbol: {
    emoji: '⚽',
    name: 'Fútbol',
    uid: 'futbol',
    disabled: true,
    maxPlayers: 11,
  },
};
